import React from "react"
import { ReactComponent as PlusSVG } from "../../assets/svg/icons/plus.svg"
import { ReactComponent as MinusSVG } from "../../assets/svg/icons/minus.svg"
import { ReactComponent as MenuSVG } from "../../assets/svg/icons/menu.svg"
import { colors } from "../../lib/colors"

export const MENU_SETTINGS = [
  {
    icon: <MenuSVG className="menu" />,
    title: "Settings Button",
    description: "Press the button to access Settings",
    background: colors.primary,
    textColor: colors.secondaryBackground,
  },
  {
    title: "Provably Fair ",
    description:
      "This section grants you the possibility of checking the fairness of the game for yourself",
  },
  {
    title: "Game Rules ",
    description: "Short Description of the Game",
  },
  {
    title: "History ",
    description:
      "Shows your previous plays and allows you to devise new tactics for your next shuffle",
  },
  {
    title: "Music ",
    description: "Turn on the unique audio overlay of the game",
  },
  {
    title: "Sound ",
    description: "Enable unique action sounds of the game",
  },
  {
    title: "Volume Bar ",
    description: "Set the volume",
  },
]

export const GAMEPLAY = [
  {
    title: "PLAY Button",
    description: "Start the game",
    icon: "PLAY",
    background: colors.secondary,
    textColor: colors.secondaryText,
    width: "100px",
    size: "12px",
  },
  {
    title: "DEAL Button",
    description: "Deal players cards",
    icon: "DEAL",
    background: colors.secondary,
    textColor: colors.secondaryText,
    width: "100px",
    size: "12px",
  },
  {
    title: "COLLECT Button",
    description: "Click collect to the win amount",
    icon: "COLLECT",
    background: colors.secondary,
    textColor: colors.secondaryText,
    width: "100px",
    size: "12px",
  },
  {
    title: "GAMBLE Button",
    description:
      'If you win your bet, you can continue the game by pressing the "GAMBLE" button to make your bet 2x or even 4x',
    icon: "GAMBLE",
    background: colors.secondary,
    textColor: colors.secondaryText,
    width: "100px",
    size: "12px",
  },
  {
    title: "HOLD",
    description: "Click on the dealed cards to hold them for the second deal",
    textColor: colors.secondaryText,
  },
  {
    title: "2X Button",
    description: "Doubles your bet instantly",
    icon: "2X",
    background: colors.secondary,
    textColor: colors.secondaryText,
  },
  {
    title: "1/2 Button",
    description: "Divides your bet by half",
    icon: "1/2",
    background: colors.secondary,
    textColor: colors.secondaryText,
  },
  {
    title: "Click on bet amount",
    description: "Additional betting options",
  },
]

export const SET_STAKE_OPTIONS = [
  {
    title: "2X Button",
    description: "Doubles your bet instantly",
    icon: "2X",
    background: colors.secondary,
    textColor: colors.secondaryText,
  },
  {
    title: "1/2 Button",
    description: "Divides your bet by half",
    icon: "1/2",
    background: colors.secondary,
    textColor: colors.secondaryText,
  },
  {
    title: "5X Button",
    description: "Multiply your bet by 5",
    icon: "5X",
    background: colors.secondary,
    textColor: colors.secondaryText,
  },
  {
    title: "+ Button",
    description: "Increase amount by single unit",
    icon: <PlusSVG />,
    background: colors.secondary,
    textColor: colors.secondaryText,
  },
  {
    title: "- Button",
    description: "Decrease amount by single unit",
    icon: <MinusSVG />,
    background: colors.secondary,
    textColor: colors.secondaryText,
  },
]
